import React from 'react';
import {withFirebase} from 'src/Firebase/context';
import Firebase from 'src/Firebase';

const AuthUserContext = React.createContext<firebase.User | null>(null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ComponentClass = (props: React.Props<any>) => JSX.Element;

export const withAuthentication = (Component: typeof React.Component): ComponentClass => {
    interface Props {
        firebase: Firebase;
    }

    interface State {
        authUser: firebase.User | null;
    }

    class WithAuthentication extends React.Component<Props, State> {
        public state: State;
        private listener: firebase.Unsubscribe;

        public constructor(props: Props) {
            super(props);
            this.state = {
                authUser: null,
            };
        }

        public componentDidMount(): void {
            this.listener = this.props.firebase.auth.onAuthStateChanged(authUser => {
                this.setState({authUser});
            });
        }

        public componentWillUnmount(): void {
            this.listener();
        }

        public render(): JSX.Element {
            return (
                <AuthUserContext.Provider value={this.state.authUser}>
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            );
        }
    }

    return withFirebase(WithAuthentication);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withAuthUser = (Component: typeof React.Component): ComponentClass => props => (
    <AuthUserContext.Consumer>
        {authUser => <Component {...props} authUser={authUser} />}
    </AuthUserContext.Consumer>
);

export default AuthUserContext;



// WEBPACK FOOTER //
// ./src/Session/context.tsx